import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MetricAction, MetricActionType, MetricModule, MetricType, Metrics } from '../../../shared/models/metrics';
import { BaseService } from '../../../shared/services/base.service';
import {
  StoreConsultantModel,
  StoreConsultantResponse,
  StoreConsultantSearchCriteria
} from '../models/store-consultant.model';

@Injectable()
export class StoreConsultantService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.storeConsultant;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public getStoreConsultantByUserId(userId: string): Observable<StoreConsultantModel> {
    const url = this.getFullUrl(this.envService.get, {
      userId: userId
    });
    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }

  public update(data: StoreConsultantModel): Observable<any> {
    const url = this.getFullUrl(this.envService.submit);
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.COUNTER,
          module: MetricModule.STORE_CONSULTANT,
          path: window.location.pathname
        }
      ]
    };

    return this.http.put<any>(url, data, {
      headers: this.loaderHeaders(3000, metricsReq),
      observe: 'body'
    });
  }

  public searchStoreConsultantByCriteria(
    criteria: StoreConsultantSearchCriteria
  ): Observable<StoreConsultantResponse> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.STORE,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams(criteria);

    return this.http.get<StoreConsultantResponse>(this.getUrl(), {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public validateFile(file): Observable<any> {
    const url = this.getFullUrl(this.envService.validateFile);

    let formData = null;
    formData = new FormData();
    formData.append('file', file, file.name);

    this.headers.append('Content-Type', 'multipart/form-data');

    return this.http.post<any>(url, formData, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  public importSubmit(data): Observable<any> {
    const url = this.getFullUrl(this.envService.importSubmit);
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.COUNTER,
          module: MetricModule.STORE_CONSULTANT,
          path: `${this.envService.importSubmit}`
        },
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.STORE_CONSULTANT,
          route: `${this.envService.importSubmit}`,
          action: MetricAction.IMPORT
        }
      ]
    };
    return this.http.post<any>(url, data, { headers: this.loaderHeaders(0, metricsReq) });
  }

  downloadFileTemplate() {
    const url = this.getFullUrl(this.envService.downloadFileTemplate);
    return this.http.get<any>(url, { headers: this.headers, responseType: 'blob' as 'json' });
  }
}
